import React from 'react';
interface TestimonialCardProps {
  initials: string;
  stars: number;
  quote: string;
  name: string;
  location: string;
  level: string;
}
function TestimonialCard({
  initials,
  stars,
  quote,
  name,
  location,
  level
}: TestimonialCardProps) {
  return <div className="bg-black border border-[#00B4D8]/30 rounded-2xl p-6 flex flex-col gap-4" data-id="element-342">
      <div className="flex items-center gap-3" data-id="element-343">
        <div className="w-12 h-12 rounded-full bg-[#00B4D8]/20 border border-[#00B4D8]/40 flex items-center justify-center text-[#00B4D8] font-black text-sm flex-shrink-0" data-id="element-344">
          {initials}
        </div>
        <div data-id="element-345">
          <div className="text-[#00B4D8] text-sm" data-id="element-346">{'⭐'.repeat(stars)}</div>
          <div className="text-white font-bold text-sm" data-id="element-347">{name}</div>
          <div className="text-gray-400 text-xs" data-id="element-348">
            📍 {location} | {level}
          </div>
        </div>
      </div>
      <p className="text-gray-300 text-sm leading-relaxed italic" data-id="element-349">"{quote}"</p>
    </div>;
}
export function TestimonialsSection() {
  return <section className="w-full bg-[#0a0a0a] py-16 px-4" data-id="element-350">
      <div className="max-w-5xl mx-auto" data-id="element-351">
        <h2 className="text-3xl sm:text-4xl font-black text-white text-center mb-4" data-id="element-352">
          Lo que dicen los profes que ya lo usan:
        </h2>
        <p className="text-gray-400 text-center mb-10" data-id="element-353">
          +300 profesores de tenis de todo el país ya tienen su MegaPack
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5" data-id="element-354">
          <TestimonialCard initials="MR" stars={5} quote="Compré un domingo a la noche. El lunes entré a la cancha con el plan exacto de la clase. Las 48 semanas del Tomo 1 son exactamente lo que necesitaba para mis grupos de iniciación. Nunca más improviso." name="Martín R." location="Buenos Aires" level="Profesor de Club de Barrio" data-id="element-355" />
          <TestimonialCard initials="CS" stars={5} quote="El sistema del Tomo 2 de técnica y táctica junior me cambió todo. El primer mes, tres alumnos que llevaban meses estancados en G4 subieron a G3. Los drills del Tomo 5 hacen la diferencia. Los uso en cada clase." name="Carolina S." location="Rosario" level="Entrenadora en Academia Privada" data-id="element-356" />
          <TestimonialCard initials="DV" stars={5} quote="El Tomo 5 de Táctica y Estrategia es único en el mercado. Patrones listos para enseñar con 1, 2, 4 u 8 alumnos. Antes tardaba 1 hora en armar una clase táctica. Ahora abro el PDF y en 5 minutos tengo todo listo." name="Diego V." location="Córdoba" level="Profesor Independiente" data-id="element-357" />
          <TestimonialCard initials="FL" stars={5} quote="El sistema de progreso con fichas mensuales eliminó las preguntas de '¿cuándo mejoro?'. Ahora el alumno lo ve con sus propios números. Y paga el abono más contento porque entiende que avanza de verdad." name="Fernando L." location="Tucumán" level="Profesor Particular y Academia" data-id="element-358" />
          <TestimonialCard initials="LP" stars={5} quote="Mi tasa de retención pasó del 40% al 80%. Sin cambiar técnicamente lo que doy. Solo aplicando el sistema de fidelización del Tomo 3 y el Abono Blindado de Academia Pro. En 4 meses llené todos mis horarios." name="Laura P." location="Mendoza" level="Profesora de Tenis" data-id="element-359" />
          <TestimonialCard initials="VT" stars={5} quote="Ahora entrego el Reglamento en la primera clase y uso el sistema de abono desde el mes 1. Los alumnos lo aceptaron todos sin problemas. Este mes cobré el 100% antes del día 5. Primera vez en mi vida." name="Valeria T." location="Santa Fe" level="Profesora de Tenis" data-id="element-360" />
          <TestimonialCard initials="AR" stars={5} quote="El Plan B Lluvia del Bono 2 me salvó el mes de julio. Llovió 3 semanas seguidas. Antes perdía esas clases y ese ingreso. Con los circuitos indoor di 20 clases sin cancha. Cobré el mes completo. Mis alumnos agradecieron el sistema." name="Ana R." location="Salta" level="Instructora en Club" data-id="element-361" />
        </div>
      </div>
    </section>;
}